import React from 'react';
import { clsx } from 'clsx';
import { Control, Controller } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/components/ui/select';
import { WORKFLOWS_ACTIONS_TYPE } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';
import type {
  WorkflowActionPath,
  WorkflowFormValues,
} from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';

const excludeTriggers = new Set([
  'handle_with_crm',
  'forward_to_email',
  'collect_and_escalate',
  'close',
]);

const WORKFLOWS_ACTIONS = Object.keys(WORKFLOWS_ACTIONS_TYPE).filter(
  (key) => !excludeTriggers.has(key),
);

export const WorkflowActionsSelect = ({
  name = 'action.0.action_type',
  control,
  isCustom = true,
}: {
  name?: `${WorkflowActionPath}.action_type`;
  control: Control<WorkflowFormValues>;
  isCustom?: boolean;
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className={'input-container'}>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <Select
              disabled={!isCustom}
              defaultValue={value}
              open={open}
              onOpenChange={setOpen}
              onValueChange={onChange}
            >
              <SelectTrigger className="w-full bg-[#a498ff1a] border border-[#a498ff80] rounded-sm-5">
                <div>
                  <p className={'text-sm font-medium'}>
                    <span>{WORKFLOWS_ACTIONS_TYPE[value]}</span>
                  </p>
                </div>
              </SelectTrigger>
              <SelectContent className={'bg-light'}>
                {WORKFLOWS_ACTIONS.map((action) => {
                  return (
                    <SelectItem
                      className={'px-4 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                      key={action}
                      value={action}
                      indicatorHidden
                    >
                      <div className="flex flex-col">
                        <div className="flex gap-2 items-center">
                          <p
                            className={clsx(
                              'text-sm text-start relative',
                              action === value ? 'font-semibold' : 'font-medium',
                            )}
                          >
                            <span>{WORKFLOWS_ACTIONS_TYPE[action]}</span>
                          </p>
                        </div>
                      </div>
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          );
        }}
      />
    </div>
  );
};
